/* eslint-disable camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composerasdfsad
 */
import {
  withLayout,
  withLayoutAccordion,

} from '@thd-olt-component-react/fusion-utils';

import {
  DisplayOnCustomer as DisplayOnCustomer_MiddlewareSlot
} from '@thd-olt-component-middleware/fourxx-middleware';

import { BrowseSearchErrorB2C, BrowseSearchErrorB2B }
from '@thd-olt-component-react/error-components';

export { BrowseSearchErrorB2C };

export { BrowseSearchErrorB2B };

let DisplayOnCustomer_MiddlewareSlot_A1 = DisplayOnCustomer_MiddlewareSlot;

const SlotA1 = withLayout(
  [

    BrowseSearchErrorB2C,

  ],

  DisplayOnCustomer_MiddlewareSlot_A1

);

let DisplayOnCustomer_MiddlewareSlot_A2 = DisplayOnCustomer_MiddlewareSlot;

const SlotA2 = withLayout(
  [

    BrowseSearchErrorB2B,

  ],

  DisplayOnCustomer_MiddlewareSlot_A2

);

const ssr = typeof window === 'undefined';

export {

  SlotA1,

  SlotA2,

};
